import type { QuarterBucket } from '../../../api/projectManagement';

/**
 * Attio fills a new deal's close date with 15 Jan 2027 when nobody sets one, so
 * that date means "not set", not a forecast. Said once on the page, not per row.
 */
export const PLACEHOLDER_CLOSE_DATE = '2027-01-15';

const BRUSSELS_DAY = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Brussels', year: 'numeric', month: '2-digit', day: '2-digit' });

/** On the Brussels calendar, like the API's quarters: Attio stores it as 00:00Z, 01:00Z or 23:00Z the day before. */
export function isPlaceholderCloseDate(iso: string | null | undefined): boolean {
  if (!iso) return false;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? false : BRUSSELS_DAY.format(d) === PLACEHOLDER_CLOSE_DATE;
}

/**
 * Pure: the quarter rows with Attio's default-close-date deals taken out of
 * their quarter and listed as one row of their own after the dated quarters
 * (12 Oct: Q1 2027 read €2.97M · 143 open, of which 107 were never dated).
 * Exported for tests.
 */
export function splitDefaultClose(buckets: QuarterBucket[]): {
  rows: QuarterBucket[];
  defaultClose: { count: number; valueEur: number } | null;
} {
  let count = 0;
  let valueEur = 0;
  const rows = buckets
    .map((q) => {
      const n = q.defaultCloseCount ?? 0;
      if (n === 0) return q;
      count += n;
      valueEur += q.defaultCloseValueEur ?? 0;
      return { ...q, count: q.count - n, valueEur: q.valueEur - (q.defaultCloseValueEur ?? 0) };
    })
    .filter((q) => q.count > 0);
  return { rows, defaultClose: count > 0 ? { count, valueEur } : null };
}
